import { JSONSchemaType } from 'ajv'

export interface INavigationFormData {
  id: string
  userId: string
  navigationDate: string
  route: string
}

const NavigationSchema: JSONSchemaType<INavigationFormData> = {
  type: 'object',
  properties: {
    userId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    navigationDate: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    route: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    id: {
      type: 'string',
    },
  },
  required: ['userId', 'navigationDate', 'route'],
  additionalProperties: false,
}

export default NavigationSchema
